import { DefaultService } from "../DefaultService";

export default class B2BCoresService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env)
    }

    find(id) {
		return this._http.get(`${this._env}/b2b/b2bcores/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
	}

    findAllCombo(...params) {
		return this._http.get(encodeURI(`${this._env}/b2b/b2bcores/getcombo/b2bcores.json?param=${params}`), this._headers).then(res => {
      return res.body;
		}, err => {
            this.handleError(err);
		});
	}
    
    updateSituacao(cor) {
		return this._http.post(`${this._env}/b2b/b2bcores/updatesituacao`, cor, this._headers).then(res => {
			return res.body;
		}, err => {
			this.handleError(err);
		});
    }

    save(form) {
		return this._http.post(`${this._env}/b2b/b2bcores`, form, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }
}